<template>
    <b-modal
      id="page-ecommerce-card-modal"
      :ok-title="trans(block && block.id ? 'save' : 'create')"
      :cancel-title="trans('cancel')"
      size="lg"
      no-enforce-focus
      @shown="onShown"
      @hidden="shown = false"
      @ok="onSave"
    >
    <template v-slot:modal-title>
      <span>{{ trans('ecommerce') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>
      <b-row>
        <b-col class="col-12">
            <DynamicForm
                v-model="formValues"
                :fields="[
                    {
                        label: trans('items_type'),
                        key: 'items_type',
                        type: 'checkboxgroup',
                        options: [
                            { text: trans('products'), value: 'products' },
                            { text: trans('memberships'), value: 'memberships' },
                            { text: trans('classes'), value: 'classes' },
                            { text: trans('packages'), value: 'packages', disabled: true },
                        ],
                        tab: trans('request_ecommmerce'),
                    },
                    {
                        label: trans('category'),
                        key: 'category_id',
                        desc: trans('category_ecommerce_desc'),
                        url: `/organization/${organization.id}/category`,
                        type: 'category',
                        tab: trans('request_ecommmerce'),
                    },
                    {
                        label: trans('exclude_category'),
                        key: 'exclude_ids',
                        url: `/organization/${organization.id}/category/list?per_page=100`,
                        type: 'tags',
                        tab: trans('request_ecommmerce'),
                    },
                    {
                        inside: trans('hide_empty_categories'),
                        key: 'hide_empty',
                        type: 'checkbox',
                        switch: true,
                        tab: trans('options'),
                    },
                    {
                        inside: trans('force_list_view'),
                        key: 'list_view',
                        type: 'checkbox',
                        switch: true,
                        tab: trans('options'),
                    },
                    {
                        label: trans('item_size'),
                        key: 'item_size',
                        type: 'radioboxgroup',
                        options: [
                            {text: '25%', value: 0.25},
                            {text: '33%', value: 0.3333},
                            {text: '50%', value: 0.5},
                            {text: '100%', value: 1.0},
                        ],
                        tab: trans('options'),
                    },
                    {
                        label: trans('default_form'),
                        key: 'default_form',
                        type: 'category',
                        //desc: trans('default_form_desc'),
                        url: `/organization/${organization.id}/checkout_form`,
                        tab: trans('options'),
                    },
                    {
                        organization: organization,
                        inside: trans('show_participant'),
                        key: 'participant',
                        type: 'participant',
                        tab: trans('options'),
                    },
                ]"
                :busy="busy"
            />

            <b-form-group :label="trans('participant_fields')" v-if="!hideClassOptions">
                <FormParticipantFields v-model="participant" :organization="organization" />
            </b-form-group>
        </b-col>
      </b-row>

      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
    </b-modal>
  </template>

  <script>
    import DynamicForm from '../../../common/components/DynamicForm'
    import FormParticipantFields from './../form-questions/FormParticipantFields'

    export default {
      props: {
        organization: Object,
        page: Object,
        block: Object,
        after: Number,
        hideClassOptions: {
            type: Boolean,
            default: true,
        }
      },
      components: {
        DynamicForm,
        FormParticipantFields
      },
      data() {
        return {
          trans: trans,
          busy: false,
          error: null,
          shown: false,
          formValues: this.block ? this.block.meta.form : {
            item_size: 0.3333,
          },
          participant: this.block ? this.block.meta.participant : {},
        }
      },
      methods: {
        onShown() {
          this.busy = false
          this.error = null
          this.shown = true
        },
        onSave(e) {
          e.preventDefault()
          this.busy = true
          this.error = null
          let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
          if (this.block && this.block.id) url += `/${this.block.id}`
          let data = {
            type: 'ecommerce',
            meta: {
                form: this.formValues,
                participant: this.participant,
            },
            after: this.after,
          }
          axios[this.block && this.block.id ? 'patch' : 'post'](url, data)
          .then(response => {
            this.busy = false
            this.$emit('saved', response.data)
            this.$bvModal.hide('page-ecommerce-card-modal')
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
          })
        },
        onClassOptionsSaved(e) {
            console.log(e)
        }
      },
      watch:{
        block(){
            this.formValues = this.block && this.block.meta && this.block.meta.form ? this.block.meta.form : {}
            this.participant = this.block && this.block.meta && this.block.meta.participant ? this.block.meta.participant : {}
        }
      },
      mounted() {
        window.pageEcommerceModal = this
      },
    }
  </script>
